import {QueryParamsForTaggingEnum} from 'presentation/constants';
import {clearBookingSearchParams} from '../clearBookingSearchParams';
import {ParamsConfigProps} from './types';

const paramsConfig = ({
	currentSearchParams,
	bookingType,
	bookingOrigin,
	setBookingData,
	ufCode,
	ufName,
	cityName,
	phone,
	email,
}: ParamsConfigProps): string => {
	setBookingData(prev => ({
		...prev,
		email,
		phone,
		ufCode: ufCode || '',
		ufName: ufName || '',
		cityName: cityName || '',
		bookingType,
		bookingOrigin,
		specialtyCode: '',
		specialtyName: '',
		subSpecialtyCode: '',
	}));
	currentSearchParams.set(QueryParamsForTaggingEnum.BOOKING_TYPE, bookingType);
	currentSearchParams.set(QueryParamsForTaggingEnum.BOOKING_ORIGIN, bookingOrigin);
	clearBookingSearchParams(currentSearchParams);
	return currentSearchParams.toString();
};

export {paramsConfig};
